// AdminLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
 import AdminSidebar from "./admin_header&footer/admin_sidebar";
import AdminHeader from "./admin_header&footer/admin_header";

const AdminLayout = () => {
  return (
    <div className="admin-container" style={{ display: "flex" }}>
       <AdminSidebar /> 
      <div className="admin-main" style={{ flex: 1 }}>
         <AdminHeader /> 
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
